import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';

const useStyles = makeStyles((theme) => ({
  dialogActions: {
    margin: theme.spacing(2),
  },
}));

const ConfirmationDialog = ({
  onClose,
  open,
  job,
  confirmedAction,
  confirmationAction,
  confirmationText,
  confirmationTitle,
}) => {
  const classes = useStyles();
  const [executingRequest, setExecutingRequest] = useState(false);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{confirmationTitle}</DialogTitle>
      <DialogContent>{confirmationText}</DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={() => {
            setExecutingRequest(true);
            confirmedAction(job);
          }}
          color={confirmationAction === 'Delete' ? 'secondary' : 'primary'}
          variant="contained"
          disabled={executingRequest}
        >
          {confirmationAction}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmationDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  job: PropTypes.object.isRequired,
  confirmedAction: PropTypes.func.isRequired,
  confirmationAction: PropTypes.string.isRequired,
  confirmationText: PropTypes.element.isRequired,
  confirmationTitle: PropTypes.element.isRequired,
};

export default ConfirmationDialog;
